<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="">
            <a-form-item label="客户姓名">
                <a-input v-model="dataForm.customer_name" allowClear placeholder="客户姓名" />
            </a-form-item>
            <a-form-item label="行程名称">
                <a-input v-model="dataForm.trip_name" allowClear placeholder="行程名称" />
            </a-form-item>
            <a-form-item label="销售">
                <a-select v-model="dataForm.user_id" style="width: 240px" placeholder="请选择" option-label-prop="label"
                    :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                        <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                            ({{ v.department.department_name }})
                        </span>
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="行程销售">
                <a-select v-model="dataForm.person_1" style="width: 180px" placeholder="行程销售人员"
                    option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                        <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                            ({{ v.department.department_name }})
                        </span>
                    </a-select-option>
                </a-select>
            </a-form-item>
            <!-- <a-form-item label="计调">
                <a-select v-model="dataForm.person_2" style="width: 180px" placeholder="行程计调人员"
                    option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                        <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                            ({{ v.department.department_name }})
                        </span>
                    </a-select-option>
                </a-select>
            </a-form-item> -->
            <a-form-item label="运营">
                <a-select v-model="dataForm.person_3" style="width: 180px" placeholder="行程运营人员"
                    option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                        <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                            ({{ v.department.department_name }})
                        </span>
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="是否有效出行">
                <a-select v-model="dataForm.valid_trip" style="width: 120px" placeholder="请选择" showSearch allowClear>
                    <a-select-option value="1">
                        有效出行
                    </a-select-option>
                    <a-select-option value="2">
                        无效出行
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="订单时间">
                <a-range-picker @change="onChangeTime2" :allowClear="true" v-model="times" value-format="yyyy/MM/DD" />
            </a-form-item>
            <a-form-item label="出行日期">
                <a-range-picker @change="onChangeTimeDays" :allowClear="true" v-model="tripdays_times"
                    value-format="yyyy-MM-DD" />
            </a-form-item>
            <a-form-model-item label="地域类型" prop="a_type">
                <a-select v-model="dataForm.a_type" style="width: 180px;" placeholder="请选择行程地域类型" allowClear>
                    <a-select-option value="1">
                        三亚
                    </a-select-option>
                    <a-select-option value="2">
                        澳门
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="行程满意度" prop="satisfaction_level">
                <a-select style="width: 200px;" allowClear v-model="dataForm.satisfaction_level" placeholder="请选择满意度">
                    <a-select-option value="1">
                        非常满意
                    </a-select-option>
                    <a-select-option value="2">
                        满意
                    </a-select-option>
                    <a-select-option value="3">
                        一般
                    </a-select-option>
                    <a-select-option value="4">
                        不满意
                    </a-select-option>
                    <a-select-option value="5">
                        未回复
                    </a-select-option>
                    <a-select-option value="6">
                        会员本人不出行
                    </a-select-option>
                    <a-select-option value="7">
                        退会
                    </a-select-option>
                    <a-select-option value="8">
                        行程取消
                    </a-select-option>
                    <a-select-option value="9">
                        客人删督导微信
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
            </a-form-item>
            <a-form-item>
                <a-button @click="exportHandle" type="primary"
                    :loading="dataListLoading || exportLoading">导出行程</a-button>
            </a-form-item>
        </a-form>
        <a-row :gutter="10">
            <a-col :span="5">
                <div style="margin: 10px 0;font-weight: bold;">👇点击员工姓名查看所属TA的做单👇</div>
                <DepartmentUsers :departmentlist="departmentlist" @onSelect="onSelect" :user_id="dataForm.person_2">
                </DepartmentUsers>
            </a-col>
            <a-col :span="19">
                <tripTable :x="2200" :columns="columns" :dataList="dataList" :dataListLoading="dataListLoading"
                    @suodan="suodan" @addOrUpdateHandle="addOrUpdateHandle" @TripProjectClick="TripProjectClick"
                    @TripOverClick="TripOverClick" @TripDeleteClick="deleteHandle">
                </tripTable>
                <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
                    :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
                    @change="pageCurrentChangeHandle" />
            </a-col>
        </a-row>
        <TripProject ref="tripProject"></TripProject>
        <TripOver ref="tripOver" @ok="query"></TripOver>
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import TripProject from "@/components/TripProject/index.vue";
import TripOver from '@/components/TripOver/index.vue'
import tripTable from "@/components/TripProject/tripTable.vue";
import addorupdate from "../trip//components/addorupdate.vue";
import DepartmentUsers from '@/components/DepartmentUsers/index.vue'
import moment from "moment";
// const trip_start = moment().format('YYYY-MM-DD 00:00:00')
//trip_start设置当前月的一号0点
const trip_start = moment().startOf('month').format('YYYY-MM-DD 00:00:00')
const trip_end = moment().format('YYYY-MM-DD 23:59:59')
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
        TripProject,
        TripOver,
        tripTable,
        DepartmentUsers
    },
    props: {
        customer_id: String,
    },
    data() {
        return {
            exportFileName: "行程明细导出",
            mixinViewModuleOptions: {
                getDataListURL: "/admin/finance/page",
                exportURL: "/admin/finance/export",
                deleteURL: "/admin/trip/delete",
                deleteTitle: "是否确定删除当前选择行程？",
                deleteContent: "删除后对应会删除行程关联的所有数据（行程项目数据，行程付款数据，行程备注等）"
            },
            times: [trip_start, trip_end],
            dataForm: {
                customer_name: "",
                trip_name: '',
                trip_start: trip_start,
                trip_end: trip_end,
                user_id: undefined,
                valid_trip: undefined,
                person_1: undefined,//销售
                person_2: undefined,//计调
                person_3: undefined, //售后
                a_type: undefined,
                satisfaction_level: undefined,
                trip_days: []
            },
            tripdays_times: [],
            departmentlist: [],
            userList: [],
            columns: [
                {
                    title: "行程名称",
                    dataIndex: "trip_name",
                    width: 200,
                    fixed: 'left'
                },
                {
                    title: "出行次数",
                    dataIndex: "playindextext",
                    width: 200,
                    scopedSlots: { customRender: "playindextext" },
                },
                {
                    title: '客户姓名',
                    dataIndex: 'customerContactInfo.customer.customer_name',
                    width: 120
                },
                {
                    title: '销售',
                    dataIndex: 'person_1info.real_name',
                    width: 120
                },
                {
                    title: "行程人数",
                    dataIndex: "person_length",
                    width: 100,
                    customRender: (text) => `${text}人`,
                },
                {
                    title: "行程天数",
                    dataIndex: "trip_days",
                    width: 100,
                    customRender: (text) => text.split(',').length + `天`,
                },
                {
                    title: "是否锁单",
                    dataIndex: "is_lock",
                    width: 120,
                    scopedSlots: { customRender: "is_lock" },
                },
                {
                    title: "行程状态",
                    dataIndex: "is_over_text",
                    scopedSlots: { customRender: "is_over_text" },
                    width: 120,
                },
                {
                    title: "项目参与人员配置",
                    dataIndex: "person",
                    scopedSlots: { customRender: "person" },
                    width: 200,
                },
                {
                    title: "行程满意度",
                    dataIndex: "satisfaction_level_text",
                    width: 120,
                },
                {
                    title: "订单时间",
                    dataIndex: "trip_createtime",
                    width: 200
                },
                {
                    title: '合计售价',
                    dataIndex: "price_total_all",
                    fixed: 'right',
                    width: 120
                },
                {
                    title: '合计成本',
                    dataIndex: "cost_total_all",
                    fixed: 'right',
                    width: 120
                },
                {
                    title: '合计利润',
                    dataIndex: "profit_total_all",
                    fixed: 'right',
                    width: 120
                },
                {
                    width: 200,
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    fixed: 'right'
                },
            ],
        };
    },
    mounted() {
        this.getAllDepartmentList();
        this.getUserList();
    },
    methods: {
        //选择
        onSelect(info) {
            console.log(JSON.parse(JSON.stringify(info)))
            const user_id = info.user_id;
            const department_id = info.department_id;
            this.dataForm.department_id = department_id;
            this.dataForm.person_2 = user_id;
            this.getDataList();
        },
        getAllDepartmentList() {
            this.$http({
                url: "/admin/user/getDepartmentSon",
                method: "get",
            }).then((res) => {
                this.departmentlist = res.data;
            });
        },
        getUserList() {
            this.$http({
                url: "/admin/user/page?page=1&limit=200",
                method: "get",
            }).then((res) => {
                this.userList = res.data.result;
            });
        },
        TripOverClick(trip_id) {
            this.$refs.tripOver.init(trip_id)
        },
        //删除行程
        TripDeleteClick(){

        },
        addOrUpdateHandle({ trip_id, customer_id }) {
            this.$refs.addOrUpdate.init(trip_id, customer_id);
        },
        TripProjectClick(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        onChangeTime2(e) {
            if (e.length == 2) {
                this.dataForm.trip_start = `${e[0]} 00:00:00`
                this.dataForm.trip_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.trip_start = undefined
                this.dataForm.trip_end = undefined
            }
        },
        //出行时间范围
        onChangeTimeDays(e) {
            if (e.length == 2) {
                const a = this.generateDateRange(e[0], e[1])
                this.dataForm.trip_days = JSON.stringify(a)
            } else {
                this.dataForm.trip_start = []
            }
        },
        /**
         * 生成两个日期之间的所有日期数组
         * @param {string} startDate - 开始日期 (格式: 'YYYY-MM-DD')
         * @param {string} endDate - 结束日期 (格式: 'YYYY-MM-DD')
         * @returns {string[]} 日期字符串数组 (格式: ['YYYY-MM-DD', ...])
         */
        generateDateRange(startDate, endDate) {
            const dateList = [];
            let currentDate = new Date(startDate);
            const endDateObj = new Date(endDate);

            // 确保结束日期不小于开始日期
            if (currentDate > endDateObj) {
                throw new Error('结束日期不能早于开始日期');
            }

            // 循环生成每一天
            while (currentDate <= endDateObj) {
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');

                dateList.push(`${year}-${month}-${day}`);
                currentDate.setDate(currentDate.getDate() + 1); // 增加一天
            }

            return dateList;
        },
        //锁单或解单
        suodan(trip_id) {
            this.$http({
                url: "/admin/trip/lock",
                method: 'post',
                data: { trip_id }
            }).then(() => {
                this.$message.success('操作成功')
                this.getDataList()
            })
        }
    },
};
</script>

<style></style>